module.exports = __webpack_public_path__ + "static/media/meme-battles.75ed6e88.jpg";